// Hero-Module
//
//
//
//
//
//
export function initHero() {

    // HERO VIDEO OBSERVER
    const heroVideo = document.querySelector("#herovideo");
    if (!heroVideo) return; // Exit if no video element found

    const videoSource = heroVideo.querySelector('source');
    if (!videoSource) return; // Exit if no source element found

    const posterImage = document.querySelector('.hero-bold-img');
    const hasPoster = posterImage && videoSource.dataset.src; // Check if we have both poster and video source

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Add video controls container
    const videoControls = document.createElement('div');
    videoControls.className = 'vidcon';
    videoControls.setAttribute('role', 'region');
    videoControls.setAttribute('aria-label', 'Video controls');
    // Keep controls hidden by default
    videoControls.style.display = 'none';

    // Add play/pause button
    const playButton = document.createElement('button');
    playButton.className = 'vidcon-btn';
    playButton.setAttribute('aria-label', 'Play video');
    playButton.setAttribute('aria-pressed', 'false');
    playButton.setAttribute('aria-controls', 'herovideo');
    playButton.setAttribute('data-playing', 'false');

    // Add play icon
    const playIcon = document.createElement('div');
    playIcon.className = 'vidcon-btn-icon is-play';
    playIcon.setAttribute('aria-hidden', 'true');
    playIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.14v14l11-7-11-7z"/></svg>';
    playButton.appendChild(playIcon);

    // Add pause icon
    const pauseIcon = document.createElement('div');
    pauseIcon.className = 'vidcon-btn-icon is-pause';
    pauseIcon.setAttribute('aria-hidden', 'true');
    pauseIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>';
    playButton.appendChild(pauseIcon);

    // Add button to controls container
    videoControls.appendChild(playButton);

    // Add controls to video container
    heroVideo.parentNode.appendChild(videoControls);

    // Add transition style to poster image only if it exists
    if (hasPoster) {
        posterImage.style.transition = 'opacity 1s ease-out';
    }

    // Handle play/pause
    playButton.addEventListener('click', () => {
        if (heroVideo.paused) {
            heroVideo.play()
                .then(() => {
                    playButton.setAttribute('aria-pressed', 'true');
                    playButton.setAttribute('data-playing', 'true');
                    if (hasPoster) {
                        posterImage.style.opacity = '0';
                        setTimeout(() => {
                            posterImage.style.display = 'none';
                        }, 1000);
                    }
                })
                .catch(e => {
                    console.log("Hero-Video is not able to play", e);
                });
        } else {
            heroVideo.pause();
            playButton.setAttribute('aria-pressed', 'false');
            playButton.setAttribute('data-playing', 'false');
        }
    });

    function loadVideo() {
        heroVideo.src = videoSource.dataset.src;
        heroVideo.load();

        // If user prefers reduced motion, don't autoplay and show controls
        if (prefersReducedMotion) {
            videoControls.style.display = 'flex';
            return;
        }

        // Otherwise, try to autoplay
        heroVideo.play()
            .then(() => {
                if (hasPoster) {
                    posterImage.style.opacity = '0';
                    setTimeout(() => {
                        posterImage.style.display = 'none';
                    }, 1000);
                }
            })
            .catch(e => {
                console.log("Hero-Video is not able to play", e);
                // Show controls if we have a poster and video failed to play
                if (hasPoster) {
                    videoControls.style.display = 'flex';
                }
            });
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Verwenden Sie requestIdleCallback oder setTimeout
                if (window.requestIdleCallback) {
                    requestIdleCallback(loadVideo);
                } else {
                    setTimeout(loadVideo, 50); // Kurze Verzögerung für Tests
                }
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: '0px',
        threshold: 0 // Triggert sofort, wenn auch nur ein Pixel sichtbar ist
    });

    // Beobachtung sofort starten
    observer.observe(heroVideo);


    // END OF MODULE
    console.log("Hero-Video initialized");
}